var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"is-light","size":"is-medium","expanded":"","disabled":_vm.saving,"loading":_vm.saving},on:{"click":_vm.transmit}},[_vm._v("Retransmit 850")])}
var staticRenderFns = []

export { render, staticRenderFns }